module.exports = __webpack_public_path__ + "img/Menu_B.90ae7177.svg";